import { forwardRef, ReactNode } from 'react';
import styled, { WebTarget } from 'styled-components';

const precompiledStyles = {
    paragraph: {
        xs: {
            R: styled.p`
                font-size: ${({ theme }) => theme.typography.paragraph.xs.size};
                line-height: ${({ theme }) => theme.typography.paragraph.xs.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.paragraph.xs.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `
        },
        sm: {
            R: styled.p`
                font-size: ${({ theme }) => theme.typography.paragraph.sm.size};
                line-height: ${({ theme }) => theme.typography.paragraph.sm.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.paragraph.sm.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `
        },
        md: {
            R: styled.p`
                font-size: ${({ theme }) => theme.typography.paragraph.md.size};
                line-height: ${({ theme }) => theme.typography.paragraph.md.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.paragraph.md.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `,
            S: styled.p`
                font-size: ${({ theme }) => theme.typography.paragraph.md.size};
                line-height: ${({ theme }) => theme.typography.paragraph.md.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.paragraph.md.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
            `
        },
        lg: {
            R: styled.p`
                font-size: ${({ theme }) => theme.typography.paragraph.lg.size};
                line-height: ${({ theme }) => theme.typography.paragraph.lg.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.paragraph.lg.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `
        },
        xl: {
            R: styled.p`
                font-size: ${({ theme }) => theme.typography.paragraph.xl.size};
                line-height: ${({ theme }) => theme.typography.paragraph.xl.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.paragraph.xl.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `
        }
    },
    uiType: {
        '3xs': {
            R: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['3xs'].R.size};
                line-height: ${({ theme }) => theme.typography.uiType['3xs'].R.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['3xs'].R.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `,
            RU: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['3xs'].RU.size};
                line-height: ${({ theme }) => theme.typography.uiType['3xs'].RU.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['3xs'].RU.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
                text-transform: uppercase;
            `,
            SU: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['3xs'].SU.size};
                line-height: ${({ theme }) => theme.typography.uiType['3xs'].SU.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['3xs'].SU.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
                text-transform: uppercase;
            `
        },
        '2xs': {
            R: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['2xs'].R.size};
                line-height: ${({ theme }) => theme.typography.uiType['2xs'].R.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['2xs'].R.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `,
            RU: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['2xs'].RU.size};
                line-height: ${({ theme }) => theme.typography.uiType['2xs'].RU.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['2xs'].RU.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
                text-transform: uppercase;
            `,
            SU: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['2xs'].SU.size};
                line-height: ${({ theme }) => theme.typography.uiType['2xs'].SU.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['2xs'].SU.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
                text-transform: uppercase;
            `,
            RL: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['2xs'].RL.size};
                line-height: ${({ theme }) => theme.typography.uiType['2xs'].RL.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['2xs'].RL.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
                text-decoration: underline;
            `,
            S: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['2xs'].S.size};
                line-height: ${({ theme }) => theme.typography.uiType['2xs'].S.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['2xs'].S.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
            `,
            SL: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['2xs'].SL.size};
                line-height: ${({ theme }) => theme.typography.uiType['2xs'].SL.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['2xs'].SL.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
                text-decoration: underline;
            `
        },
        xs: {
            R: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['xs'].R.size};
                line-height: ${({ theme }) => theme.typography.uiType['xs'].R.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['xs'].R.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `,
            S: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['xs'].S.size};
                line-height: ${({ theme }) => theme.typography.uiType['xs'].S.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['xs'].S.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
            `,
            SU: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['xs'].SU.size};
                line-height: ${({ theme }) => theme.typography.uiType['xs'].SU.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['xs'].SU.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
                text-transform: uppercase;
            `,
            RL: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['xs'].RL.size};
                line-height: ${({ theme }) => theme.typography.uiType['xs'].RL.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['xs'].RL.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
                text-decoration: underline;
            `,
            SL: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['xs'].SL.size};
                line-height: ${({ theme }) => theme.typography.uiType['xs'].SL.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['xs'].SL.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
                text-decoration: underline;
            `
        },
        sm: {
            R: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['sm'].R.size};
                line-height: ${({ theme }) => theme.typography.uiType['sm'].R.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['sm'].R.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `,
            S: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['sm'].S.size};
                line-height: ${({ theme }) => theme.typography.uiType['sm'].S.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['sm'].S.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
            `,
            RL: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['sm'].RL.size};
                line-height: ${({ theme }) => theme.typography.uiType['sm'].RL.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['sm'].RL.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
                text-decoration: underline;
            `,
            SL: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['sm'].SL.size};
                line-height: ${({ theme }) => theme.typography.uiType['sm'].SL.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['sm'].SL.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
                text-decoration: underline;
            `
        },
        md: {
            R: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['md'].R.size};
                line-height: ${({ theme }) => theme.typography.uiType['md'].R.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['md'].R.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `,
            S: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['md'].S.size};
                line-height: ${({ theme }) => theme.typography.uiType['md'].S.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['md'].S.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
            `,
            RL: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['md'].RL.size};
                line-height: ${({ theme }) => theme.typography.uiType['md'].RL.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['md'].RL.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
                text-decoration: underline;
            `,
            SL: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['md'].SL.size};
                line-height: ${({ theme }) => theme.typography.uiType['md'].SL.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['md'].SL.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
                text-decoration: underline;
            `
        },
        lg: {
            R: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['lg'].R.size};
                line-height: ${({ theme }) => theme.typography.uiType['lg'].R.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['lg'].R.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `,
            S: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['lg'].S.size};
                line-height: ${({ theme }) => theme.typography.uiType['lg'].S.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['lg'].S.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
            `
        },
        xl: {
            R: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['xl'].R.size};
                line-height: ${({ theme }) => theme.typography.uiType['xl'].R.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['xl'].R.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `,
            S: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['xl'].S.size};
                line-height: ${({ theme }) => theme.typography.uiType['xl'].S.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['xl'].S.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
            `
        },
        '2xl': {
            R: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['2xl'].R.size};
                line-height: ${({ theme }) => theme.typography.uiType['2xl'].R.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['2xl'].R.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `,
            S: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['2xl'].S.size};
                line-height: ${({ theme }) => theme.typography.uiType['2xl'].S.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['2xl'].S.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
            `
        },
        '3xl': {
            R: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['3xl'].R.size};
                line-height: ${({ theme }) => theme.typography.uiType['3xl'].R.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['3xl'].R.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.regular};
            `,
            S: styled.span`
                font-size: ${({ theme }) => theme.typography.uiType['3xl'].S.size};
                line-height: ${({ theme }) => theme.typography.uiType['3xl'].S.lineHeight};
                letter-spacing: ${({ theme }) => theme.typography.uiType['3xl'].S.letterSpacing ?? 'normal'};
                font-weight: ${({ theme }) => theme.typography.weight.semiBold};
            `
        }
    }
};

const TypographyNotFound = styled.p`
    color: red;
    font-weight: 600;
`;

const additionalStyles = {
    ellipsis: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
};

export interface TypographyProps {
    variant: 'paragraph' | 'uiType';
    size: '3xs' | '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
    modifier: 'R' | 'S' | 'RU' | 'SU' | 'RL' | 'SL';
    children: ReactNode | ReactNode[];
    className?: string;
    withEllipsis?: boolean;
}

const Typography = ({
    variant,
    size,
    modifier,
    className = '',
    children,
    withEllipsis = false,
    ...props
}: TypographyProps, ref) => {
    const Component = precompiledStyles[variant]?.[size]?.[modifier];
    const style = {};

    if (withEllipsis) {
        Object.assign(style, additionalStyles.ellipsis);
    }

    // @ts-ignore
    return Component ? (
        <Component
          className={className}
          {...props}
          style={{
              // @ts-ignore
              ...(props.style ?? {}),
              ...style
          }}
          ref={ref}
        >{children}
        </Component>
    ) : <TypographyNotFound>Desired text style doesn't exist.</TypographyNotFound>;
};

Typography.displayName = 'Typography';

export default forwardRef(Typography) as WebTarget;
